import { Col, Form, Input, Row } from "antd";
import { CantidadColumn, FormItemHiddenUi, TableUi } from "../../../ui";
import { search_inventoried_items_by_nombre_and_sku } from "../../../../actions/producto";
import { messageError } from "../../../../helpers";
import { useState } from "react";
import { UploadExcelDiv } from "./UploadExcelDiv";
import { cargar_data_excel } from "../../../../actions";

const columns = [
  {
    title: "Item",
    dataIndex: "nombre",
    key: "nombre",
  },
  {
    title: "cantidad",
    dataIndex: "cantidad",
    key: "cantidad",
    align: "right",
    render: (text, record, index) => (
      <>
        <CantidadColumn
          cantidad={record?.stockactual}
          unidadmedida_nombre={record?.prefijounidadmedida}
        />
      </>
    ),
  },
];

export const ItemForm = () => {
  const [dataBusqueda, setDataBusqueda] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const form = Form.useFormInstance();
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      const items = selectedRows.map((row) => ({
        ...row,
        cantidad: row?.stockactual || 0,
        item: row?.id,
      }));
      form.setFieldValue("items", items);
      setSelectedRowKeys(newSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      if (selected) {
        const _alldataKeys = dataBusqueda.map((item) => item.id);
        form.setFieldValue("items", dataBusqueda);
        setSelectedRowKeys(_alldataKeys);
      } else {
        form.setFieldValue("items", []);
        setSelectedRowKeys([]);
      }
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };

  const handleSearch = async (searchValue, e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data =
        await search_inventoried_items_by_nombre_and_sku(searchValue);
      setDataBusqueda(data);
    } catch (error) {
      messageError(error);
    } finally {
      setLoading(false);
    }
  };
  const handleCargarExcel = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await form.validateFields(["fileExcel"]);
      const files = form.getFieldValue("fileExcel");
      const fileExcel = files[0]?.originFileObj;
      if (fileExcel) {
        const fmData = new FormData();
        fmData.append("file", fileExcel);
        const data = await cargar_data_excel(fmData);
        setDataBusqueda(data);
      }
    } catch (error) {
      messageError("Seleccione el excel a importar");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <FormItemHiddenUi name="items" />
      <UploadExcelDiv handleCargarExcel={handleCargarExcel} loading={loading} />
      <Row style={{ paddingBottom: 8 }}>
        <Col span={24}>
          <Input.Search
            placeholder="Busqueda de items por nombre o código"
            onSearch={handleSearch}
            allowClear
            enterButton
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <TableUi
            // rowSelection={{
            //   type: "checkbox",
            //   ...rowSelection,
            // }}
            rowSelection={rowSelection}
            size="small"
            rowKey="id"
            columns={columns}
            data={dataBusqueda}
            loading={loading}
            pagination={{
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "50", "100", dataBusqueda.length],
            }}
          />
        </Col>
      </Row>
    </>
  );
};
